"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponents = void 0;
var _styles = require("@mui/material/styles");
var getComponents = exports.getComponents = function getComponents(palette) {
  var theme = (0, _styles.createTheme)({
    palette: palette
  });
  return {
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: {
          padding: '4px'
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          height: '1.554em'
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "1px solid ".concat(theme.palette.divider)
        }
      }
    }
  };
};